import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'ui/component/Button.tsx';
import { IDelete } from 'ui/component/Icons.tsx';
import { Modal } from 'ui/component/Modal.tsx';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  loading?: boolean;
};

export const DeleteDialog: React.FC<Props> = ({ isOpen, onClose, onConfirm, title, message, loading }) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="flex w-[450px] flex-col gap-8">
        <div className="flex grow items-center justify-center">
          <IDelete size={128} className="blue rounded-full bg-blue-100 p-2" />
        </div>
        <h4 className="text-center">{title}</h4>
        <p className="text-center">{message}</p>
        <div className="mt-6 flex w-full gap-4">
          <Button onClick={onClose} className="blue-outlined">
            {t('actions.back')}
          </Button>
          <Button type="submit" loading={loading} onClick={onConfirm} className="red">
            {t('actions.confirm')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
